import { gql } from '@apollo/client'

const UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS_MUTATION = gql`
  mutation updateDishTypeAdditionalIngredientsDetails(
    $id: ID!
    $data: [DishTypeAdditionalIngredientDetailsInput!]!
  ) {
    updateDishTypeAdditionalIngredientsDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      additionalIngredients {
        id
        type
      }
    }
  }
`

export default UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS_MUTATION
